import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconColorRoll: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="color-roll, paint-roller"><path d="M6.75 3.75H20.25V10.25H6.75V7V3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M6.75 7H3.75V13.25H13V15.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M15.25 21.25V18.25C15.25 17.0074 14.2426 16 13 16C11.7574 16 10.75 17.0074 10.75 18.25V21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
};

export default IconColorRoll;
